import { useState, useEffect, useRef } from "react";
import arrow from "../assets/arrow.png"; // Using the existing arrow for the scroll hint

const WelcomePage = ({ onFinish }) => {
  const [close, setClose] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    // Disable scroll on the body when the component mounts
    document.body.style.overflow = 'hidden';
    const container = containerRef.current;

    const handleDismiss = () => {
      setClose(true);
      // The onFinish callback will be called after the animation
      setTimeout(onFinish, 500); // Match animation duration
    };

    if (container) {
      container.addEventListener("wheel", handleDismiss, { once: true });
      container.addEventListener("touchmove", handleDismiss, { once: true });
    }

    return () => {
      // Re-enable scroll on the body when the component unmounts
      document.body.style.overflow = 'auto';
      if (container) {
        container.removeEventListener("wheel", handleDismiss);
        container.removeEventListener("touchmove", handleDismiss);
      }
    };
  }, [onFinish]);

  return (
    <div
      ref={containerRef}
      style={{ top: close ? "-100vh" : 0 }}
      className="welcome-container"
    >
      <div className="welcome-content">
        <h1 className="welcome-quote">
          “Look and think before opening the shutter. The heart and mind are the true lens of the camera.”
        </h1>
        <h2 className="welcome-quote-name">- Yousuf Karsh</h2>
      </div>
      <div className="scroll-down-hint">
        <span>Scroll Down or Swipe Up</span>
        <img src={arrow} alt="scroll down" className="scroll-down-arrow" />
      </div>
    </div>
  );
};

export default WelcomePage;
